import { render, staticRenderFns } from "./TableAssignBuyer.vue?vue&type=template&id=6948717e&"
import script from "./TableAssignBuyer.vue?vue&type=script&lang=ts&"
export * from "./TableAssignBuyer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports